import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { fetchMyOrders } from "../api/orders";
import { euro } from "../api/shop";

const STATUS_LABELS = {
  pending: "Pendiente",
  confirmed: "Confirmado",
  shipped: "Enviado",
  delivered: "Entregado",
  cancelled: "Cancelado",
};

export default function Account() {
  const { user, token, logout } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    fetchMyOrders(token)
      .then((data) => alive && setOrders(data))
      .catch((err) => alive && setError(err.message))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [token]);

  return (
    <div className="wrap" style={{ padding: "40px 0 90px" }}>
      <div className="pagehead" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <p className="eyebrow">Mi cuenta</p>
          <h1 style={{ fontSize: "clamp(1.9rem, 4vw, 2.6rem)" }}>Hola, {user?.name}</h1>
        </div>
        <button className="btn btn--ghost" onClick={logout}>
          Cerrar sesión
        </button>
      </div>

      <h3 style={{ margin: "30px 0 16px" }}>Tus pedidos</h3>

      {loading ? (
        <div className="hero__skeleton" style={{ height: 160 }} />
      ) : error ? (
        <div className="alert alert--error">{error}</div>
      ) : orders.length === 0 ? (
        <div className="state">
          <h3>Aún no has hecho ningún pedido</h3>
          <Link to="/moviles" className="btn btn--lg">
            Ver móviles
          </Link>
        </div>
      ) : (
        <div className="orderlist">
          {orders.map((order) => (
            <div className="ordercard" key={order._id}>
              <div className="ordercard__head">
                <div>
                  <p className="eyebrow">Pedido</p>
                  <p style={{ fontWeight: 700 }}>{order._id}</p>
                </div>
                <span className={`pill pill--${order.status}`}>{STATUS_LABELS[order.status] || order.status}</span>
              </div>

              {order.items.map((item, i) => (
                <div className="miniline" key={i}>
                  <span>
                    {item.quantity} × {item.title}
                  </span>
                  <span>{euro(item.price * item.quantity)} €</span>
                </div>
              ))}

              <div className="summary__row" style={{ marginTop: 10, borderTop: "1px solid var(--line)" }}>
                <span>Total</span>
                <b>{euro(order.total)} €</b>
              </div>

              <p style={{ fontSize: "0.8rem", color: "var(--stone)", marginTop: 8 }}>
                {new Date(order.createdAt).toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" })}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
